import { useEffect, useRef, useState } from 'react'

import { Box, Popover, PopoverArrow, PopoverContent } from '@chakra-ui/react'
import screenfull from 'screenfull'

import { PopoverTrigger } from '@/components/ui'

import { getDeviceClientRect, getTailgateClientRect } from '../../utils/chart'
import { isPopupOpen } from '../utils/utils'

export type PopoverElementKind = 'device' | 'tailgate'

export interface IProps {
  children: React.ReactNode
  elementId: string
  kind?: PopoverElementKind
  isHovering: boolean
}

const INIT_POSITION = { x: 0, y: 0, width: 0, height: 0 }

export const FloorPlanPopover = ({
  isHovering = false,
  elementId,
  children,
  kind,
}: IProps) => {
  const timeoutRef = useRef(null)
  const elementIdRef = useRef(elementId)
  elementIdRef.current = elementId

  const [triggerPosition, setTriggerPosition] = useState(INIT_POSITION)

  useEffect(() => {
    clearTimeout(timeoutRef.current)
    if (isHovering) {
      timeoutRef.current = setTimeout(() => {
        showPopover(elementIdRef.current)
      }, 1200)
    }
  }, [isHovering])

  const showPopover = (elementId: string) => {
    const clientRect = getClientRect(elementId)
    if (!clientRect) return
    setTriggerPosition(clientRect)
  }

  const getClientRect = (elementId: string) => {
    switch (kind) {
      case 'device':
        return getDeviceClientRect(elementId)
      case 'tailgate':
        return getTailgateClientRect(elementId)
    }
  }

  const onPopoverClose = () => {
    if (!screenfull.isFullscreen) {
      setTriggerPosition(INIT_POSITION)
    }
  }

  const { x, y, width, height } = triggerPosition
  return (
    <Popover
      closeOnBlur={true}
      isLazy
      isOpen={isPopupOpen(triggerPosition)}
      offset={[8, 8]}
      onClose={onPopoverClose}
      trigger='hover'
    >
      <PopoverTrigger>
        <Box
          height={height}
          left={x - 60}
          pos='absolute'
          top={y - 65}
          width={width}
        />
      </PopoverTrigger>
      <PopoverContent
        border='none'
        shadow='xl'
        width={kind === 'tailgate' ? '320px' : '400px'}
      >
        <PopoverArrow border='none' />
        {children}
      </PopoverContent>
    </Popover>
  )
}
